import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import EkoElement from "@/utilities/element";
import "@/components/icon";

@customElement("eko-page-header-help-resource")
class PageHeaderHelpResource extends EkoElement {
  // These 3 properties are the same as on the eko-action component. Ideally we
  // would use a spread props function but Lit doesn't support that.
  @property({ reflect: true, type: Boolean }) download = false;
  @property({ reflect: true }) href?: string;
  @property({ reflect: true }) target?: "_self" | "_blank" | "_parent" | "_top";

  // eslint-disable-next-line
  @property({ reflect: true }) icon?: string;
  @property({ reflect: true }) variant: "quick-start" | "how-to" | "default" = "default";

  render() {
    return html`
      <eko-action
        href=${ifDefined(this.href)}
        target=${ifDefined(this.target)}
        ?download=${this.download}>
        ${this.iconName
          ? html`<eko-icon slot="before" name="${this.iconName}"></eko-icon>`
          : nothing}
        <slot></slot>
      </eko-action>
    `;
  }

  private get iconName() {
    switch (this.variant) {
      case "quick-start":
        return "book-open-01";
      case "how-to":
        return "help-circle";
      default:
        return this.icon;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-page-header-help-resource": PageHeaderHelpResource;
  }
}

export default PageHeaderHelpResource;
